module.exports = __webpack_public_path__ + "static/media/Slide26.fd15a0bd.JPG";